import React from 'react';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../../../Features/storefrontSlice';
import LinkButton from '../../LinkButton/LinkButton';

function Bar() {
    return (
        <div className="flex items-center gap-[5px]">
            <div className="w-1/2 h-[1px] bg-[#D9D9D9]"></div>

            <p className='font-medium text-[12px] leading-3 text-[#6B7280]'>OR</p>

            <div className="w-1/2 h-[1px] bg-[#D9D9D9]"></div>
        </div>
    )
}

function Links({ link, errorText }) {
    const dispatch = useDispatch();

    function handleOpenCategoryModal() {
        dispatch(setModal('select-category'));
    }

    function handleOpenCategoryCollectionModal() {
        dispatch(setModal('select-category-collection'));
    }

    function handleOpenCustomCollectionModal() {
        dispatch(setModal('select-custom-collection'));
    }

    function handleOpenProductModal() {
        dispatch(setModal('select-product'));
    }

    return (
        <div className="flex flex-col gap-[5px]">
            <div className="flex items-center justify-between">
                <p className='font-medium text-[14px] leading-6 text-[#121212]'>Link to</p>

                {/* <p className='text-[12px] leading-5 text-[#EF4444]'>{errorText}</p> */}
            </div>

            <LinkButton 
                handlerFunction={handleOpenCategoryModal} 
                title={Object.keys(link?.category).length > 0 ? link.category.categoryName : 'category'} 
            />

            <Bar />

            <LinkButton 
                handlerFunction={handleOpenCategoryCollectionModal} 
                title={Object.keys(link.categoryCollection).length > 0 ? link.categoryCollection.CollectionName : 'collection'} 
            />

            <Bar />

            <LinkButton 
                handlerFunction={handleOpenCustomCollectionModal} 
                title={Object.keys(link.customCollection).length > 0 ? link.customCollection.CollectionName : 'custom collection'} 
            />

            <Bar />

            <LinkButton 
                handlerFunction={handleOpenProductModal} 
                title={Object.keys(link.product).length > 0 ? (link.product.productName || link.product.product.productName) : 'product'} 
            />
        </div>
    );
}

export default Links;
